export default "__VITE_ASSET__BluSvmf0__"